import { defineStore } from 'pinia';
import {
  fetchSections,
  fetchUsers,
  patchBlockUser,
  postUserAcl,
  resetPassword,
  setUserDescription,
} from '@/api/admin-be';
import { catchError, toast } from '@/helpers/toast';

export type Section = {
  id: number;
  name: string;
  description: string;
};

export type AclEntry = {
  id: number;
  userId: number;
  sectionId: number;
  read: boolean;
  write: boolean;
  section: Section;
};

export type User = {
  id: number;
  name: string;
  description: string;
  blocked: boolean;
  tempPassword?: string;
  UserToSection: AclEntry[];
};

type UsersStoreState = {
  records: User[] | null;
  sections: Section[] | null;
  loading: boolean;
};

export const useUsersStore = defineStore('users', {
  state: () =>
    ({
      records: null,
      sections: null,
      loading: false,
    }) as UsersStoreState,
  actions: {
    async banRecord(user: User) {
      return patchBlockUser(user.id)
        .then((data) => {
          user.blocked = !user.blocked;
          return data;
        })
        .catch((error) => catchError('Ошибка при блокировке пользователя', error));
    },
    async fetchRecords() {
      this.records = await fetchUsers().catch((error) =>
        catchError('Ошибка загрузки списка пользователей', error)
      );
    },
    async fetchSections() {
      this.sections = await fetchSections().catch((error) =>
        catchError('Ошибка загрузка списка разделов', error)
      );
    },
    async updateUserAcl(user: User) {
      return this.updateUser(
        await postUserAcl(user).catch((error) =>
          catchError('Ошибка обновления прав доступа', error)
        )
      );
    },
    async updateUser(newRecord: User) {
      if (this.records) {
        this.records = this.records.map((record: User) =>
          record.id === newRecord.id ? { ...record, ...newRecord } : record
        );
      } else {
        this.records = [newRecord];
      }
    },
    async resetUserPassword(user: User) {
      return this.updateUser(
        await resetPassword(user.id).catch((error) => catchError('Ошибка сброса пароля', error))
      );
    },
    async setUserDescription(user: User, description: string) {
      return setUserDescription(user.id, description)
        .then(() => {
          user.description = description;
        })
        .catch((error) => catchError('Ошибка обновления описания ползователя', error));
    },
  },
});
